import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("添加票据")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("补差")
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("%")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_descriptions, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions_item, { label: "申请金额" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.toMoney(_ctx.currentCoEstimateAmount)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "发票金额" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.toMoney(_ctx.invoiceTotalAmount)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "余额" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.toMoney(_ctx.currentCoEstimateAmount-_ctx.invoiceTotalAmount)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_space, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.addInvoice
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.addNoInvoice
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_input, {
          type: "password",
          ref: "refInput",
          class: "invoice-input",
          placeholder: "扫描添加票据",
          modelValue: _ctx.invoiceInfo,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invoiceInfo) = $event)),
          onKeyup: _withKeys(_ctx.invoiceNoEnterMethod, ["enter"])
        }, null, 8, ["modelValue", "onKeyup"])
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.invoiceData,
      align: "center",
      border: "",
      "max-height": "550px",
      class: "tableBox mt-10",
      style: {"width":"100%"},
      "row-class-name": _ctx.tableRowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "no",
          label: "CO单号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "note",
          label: "备注"
        }, {
          default: _withCtx(({row}) => [
            (!row.isEdit)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: row.note,
                  "onUpdate:modelValue": ($event: any) => ((row.note) = $event),
                  "input-style": "ime-mode:disabled",
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.note), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoiceType",
          label: "类型"
        }, {
          default: _withCtx(({row}) => [
            (!row.isEdit)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  size: "default",
                  modelValue: row.invoiceType,
                  "onUpdate:modelValue": ($event: any) => ((row.invoiceType) = $event),
                  disabled: row.isManual==1,
                  onChange: ($event: any) => (_ctx.invoiceTypeChange(row))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceTypeList, (inv, ind) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: ind,
                        label: inv.label,
                        value: inv.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.invoiceType(row.invoiceType)), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoiceNo",
          label: "发票号码"
        }, {
          default: _withCtx(({row}) => [
            (!row.isEdit)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (row.invoiceType=='SH_OR'||row.invoiceType=='SH_SP')
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        disabled: !row.invoiceType,
                        modelValue: row.invoiceNo,
                        "onUpdate:modelValue": ($event: any) => ((row.invoiceNo) = $event),
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        "remote-method": (query)=>_ctx.remoteMethod(query,row),
                        onChange: (value)=>_ctx.invoiceNoChange(value,row)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.spInvoiceList, (item, idx) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: idx,
                              label: item.invoiceNo,
                              value: item.invoiceNo
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["disabled", "modelValue", "onUpdate:modelValue", "remote-method", "onChange"]))
                    : (_openBlock(), _createBlock(_component_el_input, {
                        key: 1,
                        disabled: !row.invoiceType||row.isManual==1,
                        modelValue: row.invoiceNo,
                        "onUpdate:modelValue": ($event: any) => ((row.invoiceNo) = $event)
                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]))
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row.invoiceNo), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoiceCode",
          label: "发票代码",
          width: "150px"
        }, {
          default: _withCtx(({row}) => [
            (!row.isEdit)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: row.invoiceCode,
                  "onUpdate:modelValue": ($event: any) => ((row.invoiceCode) = $event),
                  disabled: row.isManual==1
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(row.invoiceCode), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoiceDate",
          label: "发票日期",
          width: "180px"
        }, {
          default: _withCtx(({row}) => [
            (!row.isEdit)
              ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  modelValue: row.invoiceDate,
                  "onUpdate:modelValue": ($event: any) => ((row.invoiceDate) = $event),
                  type: "date",
                  placeholder: "选择发票日期",
                  style: {"width":"100%"},
                  disabled: row.isManual==1
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(row.invoiceDate?_ctx.dayjs(row.invoiceDate).format('YYYY-MM-DD'):''), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "totalAmount",
          label: "总金额",
          align: "right"
        }, {
          default: _withCtx(({row}) => [
            (!row.isEdit)
              ? (_openBlock(), _createBlock(_component_el_input_number, {
                  key: 0,
                  style: {"width":"100%"},
                  controls: false,
                  onBlur: _ctx.handleInput,
                  modelValue: row.totalAmount,
                  "onUpdate:modelValue": ($event: any) => ((row.totalAmount) = $event),
                  disabled: !row.invoiceType
                }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue", "disabled"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.toMoney(row.totalAmount)), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "taxRate",
          label: "税率",
          width: "120",
          align: "center"
        }, {
          default: _withCtx(({row}) => [
            (!row.isEdit)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  style: {"width":"100%"},
                  onBlur: _ctx.handleInput,
                  onChange: ($event: any) => (_ctx.totalAmountChange(row,$event,'taxRate')),
                  disabled: !row.invoiceType,
                  modelValue: row.taxRate,
                  "onUpdate:modelValue": ($event: any) => ((row.taxRate) = $event)
                }, {
                  suffix: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["onBlur", "onChange", "disabled", "modelValue", "onUpdate:modelValue"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(row.taxRate) + "%", 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "taxAmount",
          label: "税额",
          align: "right"
        }, {
          default: _withCtx(({row}) => [
            (!row.isEdit)
              ? (_openBlock(), _createBlock(_component_el_input_number, {
                  key: 0,
                  style: {"width":"100%"},
                  controls: false,
                  modelValue: row.taxAmount,
                  "onUpdate:modelValue": ($event: any) => ((row.taxAmount) = $event),
                  onBlur: _ctx.handleInput,
                  onChange: ($event: any) => (_ctx.totalAmountChange(row,$event,'taxAmount')),
                  disabled: !row.invoiceType
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onChange", "disabled"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.toMoney(row.taxAmount)), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "taxExcluded",
          label: "不含税金额",
          align: "right"
        }, {
          default: _withCtx(({row}) => [
            (!row.isEdit)
              ? (_openBlock(), _createBlock(_component_el_input_number, {
                  key: 0,
                  style: {"width":"100%"},
                  controls: false,
                  modelValue: row.taxExcluded,
                  "onUpdate:modelValue": ($event: any) => ((row.taxExcluded) = $event),
                  disabled: !row.invoiceType||row.isManual==1,
                  onBlur: _ctx.handleInput,
                  onChange: ($event: any) => (_ctx.totalAmountChange(row,$event,'taxExcluded'))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onBlur", "onChange"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.toMoney(row.taxExcluded)), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "inputTaxAmount",
          label: "进项税额",
          align: "right"
        }, {
          default: _withCtx(({row}) => [
            (!row.isEdit)
              ? (_openBlock(), _createBlock(_component_el_input_number, {
                  key: 0,
                  style: {"width":"100%"},
                  controls: false,
                  modelValue: row.inputTaxAmount,
                  "onUpdate:modelValue": ($event: any) => ((row.inputTaxAmount) = $event),
                  onBlur: _ctx.handleInput,
                  onChange: ($event: any) => (_ctx.totalAmountChange(row,$event,'inputTaxAmount')),
                  disabled: !row.invoiceType || !['SP', 'SH_SP', 'EI_SP'].includes(row.invoiceType)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onChange", "disabled"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.toMoney(row.inputTaxAmount)), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "ops",
          label: "发票附件",
          width: "130px"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_TheUpBtn, {
              upText: '上传',
              upConfig: _ctx.upInvoiceConfig,
              upFetch: _ctx.upload_invoiceApi,
              upParams: {id: row.id},
              showBtn: false
            }, null, 8, ["upConfig", "upFetch", "upParams"]),
            _createVNode(_component_el_link, {
              class: "ml-10",
              onClick: ($event: any) => (_ctx.previewHandle(row))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "ops",
          label: "操作",
          width: "150px"
        }, {
          default: _withCtx((scope) => [
            (scope.row.isEdit)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  size: "small",
                  onClick: ($event: any) => (scope.row.isEdit=false)
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  size: "small",
                  type: "primary",
                  disabled: scope.row.canClick,
                  loading: scope.row.canClick,
                  onClick: ($event: any) => (_ctx.saveInvoice(scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 2
                }, 1032, ["disabled", "loading", "onClick"])),
            _createVNode(_component_el_button, {
              size: "small",
              type: "danger",
              onClick: ($event: any) => (_ctx.deleteInvoice(scope))
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name"])), [
      [_directive_loading, _ctx.invoiceLoading]
    ])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}